import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { LogoLink } from '../../shared/LogoLink';
import { HeaderSharedStyles, HeaderWedge } from './HeaderSharedStyles';
export const HeaderWithLeftLogoAndControls = ({ topRowControls, controls, }) => {
    return (_jsxs(Header, { children: [_jsxs(TopRow, { children: [_jsx(LogoLink, {}), topRowControls && (_jsx(TopRowControls, { children: topRowControls }))] }), controls && _jsx(ControlsRow, { children: controls }), _jsx(HeaderWedge, {})] }));
};
const TopRow = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const TopRowControls = styled.div `
    display: flex;
    align-items: center;
    gap: 1rem;
`;
const ControlsRow = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
`;
const Header = styled.div `
    ${HeaderSharedStyles}
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;
